import data from "../../../../../src/Button/IconButton.docs.json";
import * as React from 'react';
export default {
  data,
  React
};